/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {Entity} from '@ion/core/src/types/entities';

export interface UseEntityLabelResult {
  singularEntityLabel: string;
  pluralEntityLabel: string;
}

/**
 * Given a singular entity type (device, asset, etc) returns the translated
 * singular label (device -> Device) and plural label (device -> Devices).
 *
 * ```typescript
 *
 *  import {useEntityLabel} from '@ion/applications/src/hooks/';
 *
 *  const {
 *    singularEntityLabel,  // Device
 *    pluralEntityLabel     // Devices
 *  } = useEntityLabel(Entity.device);
 *
 * ```
 */
export const useEntityLabel = (entityType: Entity): UseEntityLabelResult => {
  const entityLabel = translate('common:entityLabels', {entity: entityType, returnObjects: true});
  return {
    singularEntityLabel : entityLabel[entityType],
    pluralEntityLabel   : entityLabel[entityType + 's']
  };
};

export default useEntityLabel;
